import {
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_FAILURE,
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_REQUEST,
  DOCUMENTS__DOCUMENT_PROGRESS_REJECT_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentsAction } from '@app/store/documents/actions';

type IsRejectingState = boolean;

const initialState: IsRejectingState = false;

export default function reducer(state: IsRejectingState = initialState, action: DocumentsAction) {
  switch (action.type) {
    case DOCUMENTS__DOCUMENT_PROGRESS_REJECT_REQUEST:
      return true;
    case DOCUMENTS__DOCUMENT_PROGRESS_REJECT_SUCCESS:
    case DOCUMENTS__DOCUMENT_PROGRESS_REJECT_FAILURE:
      return false;
    default:
      return state;
  }
}
